import confetti from 'canvas-confetti'
import { useEffect } from 'react'
import type Badge from '../../model/Badge'
import AppIcon from '../icons/AppIcon'
import Button from '../primitives/Button'
import Overlay from '../primitives/Overlay'
import styles from './VictoryOverlay.module.css'

interface VictoryOverlayProps {
  quip: string
  rms: number
  message: string
  earnedBadge?: Badge
  confettiColors: string[]
  onDone: () => void
  onLogAnother: () => void
}

export default function VictoryOverlay({
  quip,
  rms,
  message,
  earnedBadge,
  confettiColors,
  onDone,
  onLogAnother,
}: VictoryOverlayProps) {
  useEffect(() => {
    confetti({
      particleCount: 80,
      spread: 70,
      origin: { y: 0.35 },
      colors: confettiColors,
      zIndex: 10002,
      disableForReducedMotion: true,
    })
    // Victory overlay mounts once per log; confetti should fire exactly once.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <Overlay>
      <div className={styles.burst} />
      <div className={[styles.victory, styles.content].join(' ')} data-testid="victory-overlay">
        <div className={styles.quip}>{quip}</div>
        <div className={styles.big}>
          +{rms}
          <span className={styles.bigUnit}>RMs</span>
        </div>
        <p className={styles.msg} dangerouslySetInnerHTML={{ __html: message }} />

        {earnedBadge && (
          <div className={styles.badge}>
            <div className={styles.badgeIcon}>
              <AppIcon icon="mdi:star" size={15} />
            </div>
            <div className={styles.badgeText}>
              New badge · <b>{earnedBadge.name}</b>
            </div>
          </div>
        )}

        <div className={styles.btns}>
          <Button onClick={onDone}>Done</Button>
          <Button variant="ghost" onClick={onLogAnother}>
            Log another
          </Button>
        </div>
      </div>
    </Overlay>
  )
}
